import { Injectable } from '@angular/core';
import { ApiResponse } from '../../../shared/models/api-response.model';
import { InfluencerDetails } from '../models/influencerdetails.model';
import { Observable } from 'rxjs';
import { ApiRoutes } from '../../../shared/constants/api-routes.constants';
import { HttpClient } from '@angular/common/http';
import { VoteRequest } from '../models/vote.model';
import { toFormData } from '../../../shared/utils/form-data.util';
import {
  MediaResponse,
  MediasWithPagination,
} from '../../influencer/modules/media/models/media.model';
import { PageData } from '../../../shared/models/page-response.model';

@Injectable({
  providedIn: 'root',
})
export class InfluencerDetailsService {
  constructor(private http: HttpClient) {}

  getInfluencerDetails(
    username: string
  ): Observable<ApiResponse<InfluencerDetails | null>> {
    return this.http.get<ApiResponse<InfluencerDetails | null>>(
      ApiRoutes.USER.GET_INFLUENCER_DETAILS(username)
    );
  }

  createVote(voteData: VoteRequest): Observable<ApiResponse<null>> {
    const votePayload = toFormData({ ...voteData });
    return this.http.post<ApiResponse<null>>(
      ApiRoutes.VOTE.CAST_VOTE,
      votePayload
    );
  }

  getInfluencersPosts(
    mediaWithPagination: MediasWithPagination
  ): Observable<ApiResponse<PageData<MediaResponse>>> {
    return this.http.get<ApiResponse<PageData<MediaResponse>>>(
      ApiRoutes.MEDIA.GET_INFLUECER_POSTS_BY_USERNAME(
        mediaWithPagination.userName,
        mediaWithPagination.pageNumber
      )
    );
  }

  getInfluencerSubscribedPosts(
    mediaWithPagination: MediasWithPagination
  ): Observable<ApiResponse<PageData<MediaResponse>>> {
    return this.http.get<ApiResponse<PageData<MediaResponse>>>(
      ApiRoutes.MEDIA.GET_INFLUECER_SUBSCRIBED_POSTS_BY_USERNAME(
        mediaWithPagination.userName,
        mediaWithPagination.pageNumber
      )
    );
  }
}
